import Vue from "vue";

import _MainIndex from "./MainIndex.vue";
export const MainIndex = Vue.component("g2082-main-index", _MainIndex);
